import { useEffect, useRef, useState } from 'react';

export default function useScrollProgress() {
    const [progress, setProgress] = useState(0);
    const requestRef = useRef<number>(0);

    useEffect(() => {
        const updateScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

            setProgress(scrollPercent);
            requestRef.current = 0;
        };

        const handleScroll = () => {
            if (!requestRef.current) {
                requestRef.current = requestAnimationFrame(updateScroll);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        };
    }, []);

    return progress;
}
